import * as angular from 'angular';

import { ComponentDefinition, PerformanceInformationDTO } from '../../models/';
import { IPerformanceService, ILoggerService } from '../../services/';

class PerformanceInformationDetailsController implements angular.IComponentController {
    dateFormat: string;
    isLoading: boolean;
    loadingMessage: string;
    performanceInformation: PerformanceInformationDTO;

    static $inject = [
        'performanceService',
        'loggerService'
    ];

    constructor(
        private _performanceService: IPerformanceService,
        private _loggerService: ILoggerService
    ) {
    }

    $onInit() {
        this.init();
    }

    private init(): void {
        this.isLoading = true;
        this._loggerService.log('Try to retrieve performance data', false);

        this._performanceService
            .getEnvironment()
            .then((data: PerformanceInformationDTO) => {
                this.performanceInformation = data;
                this._loggerService.log('Performance data retrieved', false);
            })
            .finally(() => this.isLoading = false);
    }
}

export const wtPerformanceInformationDetails: ComponentDefinition = {
    componentId: 'wtPerformanceInformationDetails',
    controller: PerformanceInformationDetailsController,
    template: require('./performanceInformationDetails.component.html'),
    controllerAs: 'vm',
    bindings: {

    }
};
